import { render, staticRenderFns } from "./rackList403.vue?vue&type=template&id=bf620c20"
import script from "./rackList403.vue?vue&type=script&lang=js"
export * from "./rackList403.vue?vue&type=script&lang=js"
import style0 from "./rackList403.vue?vue&type=style&index=0&id=bf620c20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports